<div class="full-page-container">
  <fgb-page-header
    [pageTitle]="'wallet.page.title'"
    [backButtonLink]="'/'"
    [showBalance]="false"
    [showFooter]="false"
    [showQr]="false"
  ></fgb-page-header>
  <fgb-barcode></fgb-barcode>

  <div #walletContainer class="wallet-container">
    <ng-container *ifScreenSize="screenType.Mobile">
      <div class="grab-point"><span class="minimize-icon"> </span></div>
    </ng-container>

    <div class="d-none d-lg-block">
      <fgb-banner [title]="'wallet.page.title' | translate"></fgb-banner>
      <fgb-mixed-loyalty-nav></fgb-mixed-loyalty-nav>
    </div>

    <!-- Wallet -->
    <ng-container *ngIf="walletItems$ | async as walletItems">
      <div class="wallet-redeem-carousel">
        <div class="container">
          <fgbcl-rewards-wallet-redeem-list [unRedeemedItems]="walletItems"></fgbcl-rewards-wallet-redeem-list>
        </div>
      </div>
    </ng-container>

    <div class="container">
      <div class="history-container">
        <div class="history">
          <h5 class="title">{{ 'redemption.history.title' | translate }}</h5>
          <p class="description font-size-14 mb-0">{{ 'redemption.history.description' | translate }}</p>
        </div>
        <a class="font-size-14 claimed-text fw-bold text-center" [routerLink]="['/rewards/claimed']">
          {{ 'rewards.wallet.view.claimed' | translate }}
        </a>
      </div>
    </div>
  </div>
</div>
